export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        blockModifiers: ['centerBottom'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                header1: 'What is<br>content commerce?',
                text2: "Content commerce is content and commerce in synergy. Sales triggered by inspiration with engaging content, means for sellers to reach new customers, and the most convenient way possible for customers to buy what they discover. With content commerce you can buy anything from any type of digital content (on any type of platform) directly from the seller, without being redirected somewhere else with links.",
              }
            },
            bottom: {
              component: 'video-full',
              data: {
                showSlider: true,
                blockModifiers: ['endMargin', 'sideMargins'],
                src: 'desktop_spot.mp4',
                srcMobile: 'mobile_spot.mp4',
              }
            }
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['alignTop'],
                component1: {
                  type: 'animation',
                  data: {
                    blockModifiers: ['smallBottomMargin'],
                    loop: true,
                    autoplay: true,
                    animationSpeed: 0.1,
                    src: "marketing_to_commerce.json",
                  }
                },
                text2: "<p>Content marketing has long been the way for brands to be in the right context, and for publishers to monetize their content. At the same time, there has never been a true connection between the content and the product since the content hasn’t been able to deliver a direct sale capability. Making sales at the right place and time is of course key to success.</p><p>Until now the customer journey has never been seamless. Usually customers have had to search for where to buy the product somewhere else after reading about it. In the best case customers have been sent somewhere else without knowing where the link will take them. For brands this redirection of customers lead to dropped carts, or customers being sent to someone else. For content makers it means losing their audience with sending them somewhere else, and that the business focus shifts from content to reader traffic. For people reading content, and who wants to buy what they discover this of course leads to far from convenient experience.</p><p>By connecting e-commerce with content marketing it’s now possible to make a purchase directly from within the content. A seamless and friction-free experience all the way from discovery to placing the order - without being redirected.</p>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Content commerce<br>VS affiliate marketing.',
                text2: "<p>With affiliate marketing publishers add an affiliate link in connection with their digital content. The link takes the visitor to a website where they can buy the product.</p><p>The biggest difference between affiliate marketing and content commerce is that affiliate links redirects the visitor from the content to another website where the visitor can buy the product.</p><p>With Spotin and content commerce the visitor gets in-depth information and the opportunity to buy the product directly, without having to be redirected to another website. It’s like opening a store directly where potential customers are, instead of having the visitors leave the content to come to the store.</p>",
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                header1: 'Content commerce.<br>A long-term business solution.',
                text2: "At Spotin we believe that the online future belongs to brands (big or small) and to all the publishers and content makers creating great content, rather than tech giants making money on ads and by redirecting people all over. We want to give the power back to the brands and publishers by providing a new generation of online content and commerce.",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Commerce on the<br>terms of brands,<br>content makers and<br>people.',
                text2: "<p>Through this new type of commerce provided by Spotin brands get to distribute their e-com and create new sales channels. They can give their products increased exposure and availability in the ideal context: within the publisher’s genuine content. It’s also a way of meeting customers when the buying interest is at an all-time high. For the brands this means higher conversion rates and a process easier to measure.</p><p>At the same time, content creators get to keep visitors on their content instead of directing them away with links. They get to generate an income through revenue sharing, so that they can keep creating engaging content. They also get to offer their visitors an added value by giving the visitors the opportunity to shop directly on the publisher’s site, get in-depth information and find more products they might like.</p><p>With content commerce people get to discover brands and products within the content, instead of searching. They get all the info they need to shop on the spot, directly from the brands. People can shop products from different brands and then complete the order in one check out. In short, a much more convenient experience.</p>",
              }
            },
            bottom: {
              component: 'image-block',
              data: {
                blockModifiers: ['sideMargins'],
                src: "venn_content_commerce.svg",
                srcMobile: "venn_content_commerce_mobile.svg",
                alt: "Brands / Content makers / People venn diagram",
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Related'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for<br>brands & sellers',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'sellers',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Spotin for<br>content makers',
                    blockModifiers: ['offWhiteOnBlue', 'alignLabelLeft', 'alignLabelTop'],
                    path: 'publishers',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Contentcommerce.js